import axios from 'axios';
import { tecDocUrl, PROVIDER_ID, basicAuth } from 'utils/constantsHelper';
import { langCode } from 'utils/currentLanguage';

export const getCarsByVin = (vinNumber, articleCountry, config) => {
  return axios.post(
    tecDocUrl,
    {
      getVehiclesByVIN: {
        country: articleCountry,
        vin: vinNumber,
        provider: PROVIDER_ID,
        lang: langCode,
        articleCountry: articleCountry,
      },
    },
    { headers: basicAuth, ...config }
  );
};



// WEBPACK FOOTER //
// ./src/utils/getCarsByVin.js